import React from 'react';
import { Stack, Typography, Autocomplete, TextField } from '@mui/material';

function ProcedureSearchDropdown({ options, value, onSelect, placeholder = 'Search by procedure name or ID...', sx = {} }) {
    const selectedProcedure = options.find(option => option.id === value) || null;

    return (
        <Autocomplete
            options={options}
            value={selectedProcedure}
            onChange={(event, newValue) => {
                onSelect(newValue ? newValue.id : '');
            }}
            getOptionLabel={(option) => option.name + ', ID: ' + option.external_id}
            renderOption={(props, option) => (
                <li {...props} key={option.id}>
                    <Stack>
                        <Typography variant="normal">{option.name}</Typography>
                        <Typography variant="caption" color="text.secondary">
                            ID: {option.external_id}
                        </Typography>
                    </Stack>
                </li>
            )}
            filterOptions={(options, { inputValue }) => {
                return options.filter((option) =>
                    option.name.toLowerCase().includes(inputValue.toLowerCase()) ||
                    option.external_id?.toLowerCase().includes(inputValue.toLowerCase())
                );
            }}
            renderInput={(params) => (
                <TextField
                    {...params}
                    variant="standard"
                    placeholder={placeholder}
                />
            )}
            sx={{ width: '50%', ...sx }}
        />
    );
}

export default ProcedureSearchDropdown;
